import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { membersKeys } from "@/features/members/queries/membersQueryKeys";
import membersService from "@/features/members/services/membersService";

/**
 * Mutation hook for revoking member access
 * Invalidates member detail query on success
 */
export function useRevokeAccess(uid: string) {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await membersService.revokeAccess(uid);
        },
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : "Failed to revoke access. Please try again.";
            toast.error(errorMessage);
        },
        onSuccess: () => {
            // Invalidate member detail query to refresh data
            queryClient.invalidateQueries({
                queryKey: membersKeys.detail(uid),
            });
        },
    });

    return {
        error: mutation.error,
        isError: mutation.isError,
        isPending: mutation.isPending,
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
    };
}
